export default function getStyle() {
  return {
    message: {
      textAlign: 'left'
    }
  }
}